import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[flagFallback]'
})
export class FlagFallbackDirective implements OnInit {
  @Input('flagFallback') countryCode!: string;
  @Input() emojiFlag!: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Render emoji first
    this.el.nativeElement.textContent = this.emojiFlag;

    // Defer check so DOM paints
    setTimeout(() => {
      if (!this.hasRenderedEmoji()) {
        this.renderer.addClass(this.el.nativeElement, 'fi');
        this.renderer.addClass(this.el.nativeElement, `fi-${this.countryCode.toLowerCase()}`);
        this.el.nativeElement.textContent = ''; // clear fallback text
      }
    });
  }

  private hasRenderedEmoji(): boolean {
    // Measure width: if emoji not supported, width ≈ plain letters
    const testEl = this.renderer.createElement('span');
    this.renderer.setStyle(testEl, 'visibility', 'hidden');
    testEl.textContent = this.emojiFlag;
    this.renderer.appendChild(document.body, testEl);

    const width = testEl.offsetWidth;
    this.renderer.removeChild(document.body, testEl);

    return width > 0 && width !== this.emojiFlag.length * 8; // rough heuristic
  }
}
